// LO QUE LA ESTACIÓN MANDA AL SERVIDOR · DISEÑO-F5 §7.1 (TP-10)
//
// Aparte del componente por el lint de Fast Refresh
// (react-refresh/only-export-components): aquí no hay JSX.
export const OPERACIONES = [
  ['CONSUMO', 'Sacar', 'Lo que se toma de la repisa para usarlo o venderlo.'],
  ['ENTRADA', 'Meter', 'Lo que llega y se acomoda en la repisa.'],
  ['CONTEO', 'Contar', 'Decir cuántas piezas hay de verdad, sin mover nada.'],
  ['TRASPASO', 'Pasar a otro lugar', 'Llevar piezas de esta repisa a otra ubicación.'],
];

export const SKU_LIMPIO = (s) => (s || '').trim().toUpperCase();

/** El cuerpo que se manda al PUT, a partir de lo que la persona eligió. */
export function cuerpoDeGuardado({ idUbicacion, operaciones, todos, elegidos, botones, destinos }) {
  const cuerpo = { operaciones };
  if (idUbicacion) cuerpo.id_ubicacion = idUbicacion;
  cuerpo.productos = todos ? { todos_de_la_ubicacion: true } : elegidos.map(SKU_LIMPIO).filter(Boolean);
  cuerpo.presets = botones
    .filter((b) => b.modo === 'FIJO' && SKU_LIMPIO(b.sku) && String(b.cantidad || '').trim())
    .map((b) => ({ n: b.n, sku: SKU_LIMPIO(b.sku), cantidad: String(b.cantidad).trim() }));
  cuerpo.destinos = operaciones.includes('TRASPASO') ? destinos : [];
  return cuerpo;
}
